import React, { useState, useEffect } from 'react'
import lozad from 'lozad'
import loadable from '@loadable/component'

const Polyfill = loadable.lib(() => import('intersection-observer'))

export default function useLazyLoad (aboveTheFold, lozadSettings) {
  const [observer, setObserver] = useState(null)

  useEffect(() => {
    const lazyObserver = lozad(lozadSettings?.selector, lozadSettings?.options) // lazy loads elements with default selector as '.lozad'
    lazyObserver.observe()
    setObserver(lazyObserver)
  }, [lozadSettings])

  // Function to refresh lazy load
  const refreshLazyLoad = () => {
    if (observer) observer.observe()
  }

  const renderPolyFill = () => (
    <>
      {!aboveTheFold && shouldLoadPolyFill() && (
        <Polyfill>{({ default: polyfill }) => <></>}</Polyfill>
      )}
    </>
  )

  return { refreshLazyLoad, renderPolyFill }
}

function shouldLoadPolyFill () {
  if (typeof window !== 'object') {
    return false
  }

  // Exit early if all IntersectionObserver and IntersectionObserverEntry
  // features are natively supported.
  if (
    'IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype
  ) {
    // Minimal polyfill for Edge 15's lack of `isIntersecting`
    // See: https://github.com/w3c/IntersectionObserver/issues/211
    if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
      Object.defineProperty(
        window.IntersectionObserverEntry.prototype,
        'isIntersecting',
        {
          get: function () {
            return this.intersectionRatio > 0
          },
        }
      )
    }
    return false
  }

  return true
}
